import React, { useMemo, useState } from "react";

import PodcastHeader from "./PodcastHeader";
import PodcastEpisode from "./PodcastEpisode";
import PodcastPlayer from "./PodcastPlayer";

import { podcastEpisodes } from "../../../resources/podcastEpisodes";

const INITIAL_EPISODES = 4;

export default function Podcast() {

    const [episodes] = useState(podcastEpisodes);
    const [currentEpisode, setCurrentEpisode] = useState(null);
    const [showAllEpisodes, setShowAllEpisodes] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("newest");

    const filteredEpisodes = useMemo(() => {

        let data = [...episodes];

        if (search !== "") {
            const term = search.toLowerCase();
            data = data.filter(ep =>
                ep.title.toLowerCase().includes(term) ||
                ep.description.toLowerCase().includes(term)
            );
        }

        if (sortOrder === "oldest") {
            data.sort((a, b) =>
                new Date(a.published) - new Date(b.published));
        }

        if (sortOrder === "newest") {
            data.sort((a, b) =>
                new Date(b.published) - new Date(a.published));
        }

        return data;

    }, [episodes, search, sortOrder]);

    const displayedEpisodes = showAllEpisodes
        ? filteredEpisodes
        : filteredEpisodes.slice(0, INITIAL_EPISODES);

    function handleEpisodeSelected(episode) {

        if (
            currentEpisode &&
            currentEpisode.guid === episode.guid
        ) {
            setIsPlaying(true);
            return;
        }

        setCurrentEpisode(episode);
        setIsPlaying(true);

    }
    function handleTogglePlayPause() {
        setIsPlaying(previous => !previous);
    }
    //-------------------------------------------------------

    return (

        <div className="podcast">
            {/*}
            <PodcastHeader
                episodeCount={episodes.length}
                search={search}
                setSearch={setSearch}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
            />
*/}

            <PodcastPlayer
                episode={currentEpisode}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
            />

            <div className="episode-list pt-20">
                {displayedEpisodes.map(episode => (
                    <PodcastEpisode
                        key={episode.guid}
                        episode={episode}
                        currentEpisode={currentEpisode}
                        isPlaying={isPlaying}
                        onEpisodeSelected={handleEpisodeSelected}
                        onTogglePlayPause={handleTogglePlayPause}
                    />
                ))
                }
            </div>
            {filteredEpisodes.length > INITIAL_EPISODES && (

                <div className="episode-description-toggle hover-opacity-50 font-raleway font-size-20l-18m-16s font-weight-600 txt-fff align-center line-height-125per pt-10"

                    onClick={() =>
                        setShowAllEpisodes(previous => !previous)
                    }
                >

                    <span>
                        {
                            showAllEpisodes
                                ? "Show Less Episodes"
                                : `Show ${filteredEpisodes.length -
                                INITIAL_EPISODES
                                } More Episodes`

                        }

                    </span>

                    <span className="episode-chevron pl-5">
                        {showAllEpisodes
                            ? "▲"
                            : "▼"
                        }
                    </span>
                </div>

            )

            }
        </div>

    );

}